skrilla.directive('incompleteUsers',function() {
    return {
        templateUrl: 'directives/incompleteUsers/incompleteUsers.html',
        scope: {
        },
        controller: function($scope, cacheService, modalService, searchService, paginationService, queryService){
            $scope.key = "incompleteUsers";
            $scope.incompleteUsers = cacheService.getObjectOrElse("incompleteUsersTable", []);
            $scope.reset = function () {
                $scope.query = {
                    email: "",
                    limit: 20
                };
            };
            $scope.reset();

            $scope.search = function () {
                paginationService.resetPage($scope.key);
                paginationService.pageQuery(getUsers, $scope.key);
            }

            var getUsers = function () {
                return searchService.get("users/noProfiles" + queryService.getQueryString($scope.query, $scope.key)).then(function (response) {
                    $scope.incompleteUsers = response.data.result;
                    cacheService.registerObject("incompleteUsersTable", $scope.incompleteUsers);
                    paginationService.setPage($scope.key, paginationService.buildPage(response));
                });
            }

            $scope.delete = function(id){
                modalService.confirm("Are you sure you'd like to permanently delete this user?",function(){
                    searchService.deleteRequest("users/" + id, "User successfully deleted").then(function(response){
                       $scope.search();
                    });
                });
            }

        }
    };
});
